var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ice-notify"},[_c('div',{staticClass:"close",on:{"click":_vm.$thisFrame.close}},[_vm._v("X")]),_c('div',{staticClass:"template-normal"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.content)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }